import { BEDROOM_COUNTS } from "../constants";

export function findBedroomCountByLabel(value: string) {
    const foundValue = BEDROOM_COUNTS.find((bedroomCount) => {
        return bedroomCount.label === value
    })

    return foundValue?.value
}